/**
 * NOTE: This is generated file any changes to it can be overwritten at some point
 */
import React from 'react';

import { createSvgIcon } from '../utils';

const CertificateIcon = /*#__PURE__*/ createSvgIcon(
  'CertificateIcon',
  {
    ltr: {
      large: ({ id }) => (
        <>
          <path
            d="M13.996 9.136l-1.142.87c-.057.045-.117.045-.18 0-.062-.046-.082-.103-.059-.17l.443-1.416-1.176-.92c-.056-.045-.074-.102-.05-.17.022-.069.073-.103.153-.103h1.414l.444-1.397c.022-.069.073-.103.153-.103s.13.034.153.103l.444 1.397h1.414c.08 0 .131.034.154.103.022.068.005.125-.051.17l-1.177.92.444 1.415c.022.068.002.125-.06.17-.063.046-.122.046-.179 0l-1.142-.869z"
            fill="currentColor"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M19 8c0 1.41-.584 2.684-1.523 3.593v3.398a.832.832 0 01-1 .814l-2.613-.54-2.614.54a.832.832 0 01-1-.814v-3.684A5 5 0 1119 8zm-5 3.5a3.5 3.5 0 100-7 3.5 3.5 0 000 7zm0 1.5c.702 0 1.37-.145 1.977-.406v1.576l-2.113-.436-2.114.436v-1.704A4.98 4.98 0 0014 13z"
            fill="currentColor"
          />
          <path
            d="M8.25 5.5H2.5v11h15.75a.75.75 0 010 1.5H2.5c-.413 0-.766-.147-1.06-.44A1.445 1.445 0 011 16.5v-11c0-.412.147-.766.44-1.06.294-.293.647-.44 1.06-.44h5.75a.75.75 0 010 1.5z"
            fill="currentColor"
          />
        </>
      ),
    },
  },
  false
);

export default CertificateIcon;
